import { PurchaseOrderRow } from 'modules/purchaseOrders/types/purchaseOrderRow'

export const getItemsTotalAmount = (currentItemsValues: PurchaseOrderRow[] | undefined): number | undefined => {
  return (
    currentItemsValues?.reduce((acc: number, { rate, qty }: PurchaseOrderRow) => acc + (rate || 0) * (qty || 0), 0) ||
    undefined
  )
}
